import { ChangeDetectionStrategy, Component, Input, HostBinding, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: `bll-icon`,
  template: ``,
  host: {
    'aria-hidden': 'true',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BllIconComponent implements OnInit, OnChanges {
  @Input() name = '';
  @Input() size: 'sm' | 'md' | 'xl';
  @Input('class') classNames = '';
  @HostBinding('class') currentClassNames;

  ngOnInit() {
    this.setClassNames();
  }

  ngOnChanges(changes) {
    if (changes.classNames || changes.name) {
      this.setClassNames();
    }
    // 'size' change
  }

  setClassNames() {
    if (this.name) {
      this.name = this.name.replace(/^icon-/g, '');
    }
    this.currentClassNames = `icon icon-${this.name} ${this.classNames}`.trim();
  }
}
